<svg
  data-test="EMWlQ8_J"
  xmlns="http://www.w3.org/2000/svg"
  style="
    border: 0 !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
  "
  class="root-svg-symbols-element"
>
  <symbol id="icon-check" viewBox="0 0 9.07 6.95">
    <path
      data-name="path0 fill"
      d="M8.78 1.71L3.83 6.66a1 1 0 0 1-1.41 0L.29 4.54a1.004 1.004 0 0 1 1.42-1.42l1.41 1.42L7.36.29a1.004 1.004 0 0 1 1.42 1.42z"
    />
  </symbol>
  <symbol id="icon-view-compact-2" viewBox="0 0 12 12">
    <rect width="5" height="5" rx="1"></rect>
    <rect width="5" height="5" rx="1" transform="translate(0 7)"></rect>
    <rect width="5" height="2" rx="1" transform="translate(7 10)"></rect>
    <rect width="5" height="2" rx="1" transform="translate(7 5)"></rect>
    <rect width="5" height="2" rx="1" transform="translate(7)"></rect>
  </symbol>
  <symbol id="icon-view-compact" viewBox="0 0 12 12">
    <rect width="12" height="2" rx="1"></rect>
    <rect width="12" height="2" rx="1" transform="translate(0 10)"></rect>
    <rect width="8" height="2" rx="1" transform="translate(4 5)"></rect>
  </symbol>
  <symbol id="icon-view-grid" viewBox="0 0 12 12">
    <path
      d="M1 12a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H1zm7 0a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H8zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm7 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H8z"
    ></path>
  </symbol>
  <symbol id="icon-view-list" viewBox="0 0 12 12">
    <rect width="12" height="2" rx="1"></rect>
    <rect width="12" height="2" rx="1" transform="translate(0 10)"></rect>
    <rect width="12" height="2" rx="1" transform="translate(0 5)"></rect>
  </symbol>
</svg>
